import { GcliRateGroup } from "../features/actuarial/rates-state";

export const ratesFormat66To80GCLI = (data: GcliRateGroup[]) => {
    const result: Record<string, any[]> = {};

    data.forEach((group) => {
        const key = `age_${group.title}`;

        result[key] = group.data.map((item: any) => ({
            // term_or_months: item.rider_id,
            term_of_months: item.rider_id,
            basic_rate: item.amount || "0",
        }));
    });

    return result;
}

export const generateFormatRatesGCLI = (data: GcliRateGroup[], basicPlanId: number) => {
    const result: Record<string, any[]> = {};
    
    data.forEach((group) => {
        const key = `age_${group.title}`;

        result[key] = group.data.map((item: any) => ({
            // term_or_months: item.rider_id,
            term_of_months: item.rider_id,
            basic_rate: item.amount || "0",
        }));
    });

    // return result;
    return {
        // [ageRange]: {
            basic_plan_id: basicPlanId,
            ...result,
        // },
    };
} 